<template>
    <div class="calendar-legend vx-card no-shadow card-border">
      <h3>Legend</h3>
      <ul class="legend-list">
        <li v-for="(color, type) in eventColors" :key="type">
          <span :style="{ backgroundColor: color }" class="legend-color"></span>
          {{ type }}
        </li>
      </ul>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      eventColors: {
        type: Object,
        required: true
      }
    }
  }
  </script>
  
  <style scoped>
  .calendar-legend {
    padding: 1em;
    border-radius: 8px;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
  }
  
  .calendar-legend h3 {
    margin: 0 0 0.5em 0;
    font-size: 16px;
  }
  
  .legend-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 1em;
  }
  
  .legend-list li {
    display: flex;
    align-items: center;
    margin-bottom: 0;
  }
  
  .legend-color {
    width: 16px;
    height: 16px;
    display: inline-block;
    margin-right: 6px;
    border-radius: 3px;
    border: 1px solid #ccc;
  }
  </style>
  